import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PublicDoc from './screens/PublicDoc';
import PayScreen from './screens/PayScreen';
import VendorTerms from './screens/VendorTerms';
import { I18nProvider } from './i18n';

// ── /d/estimate/<token> ────────────────────────────────────────────────────
//
// A customer's link renders the document and NOTHING else — not the app, not
// the session restore, not the sign-in screens. Decided here rather than
// inside App because the point is that none of App runs: a page a stranger
// opens should have no path into the authenticated application at all.
//
// A trailing "s" is accepted because this link gets forwarded, retyped and
// pasted into text messages.
//
// `lead-estimate` is a QPS job's own estimate rather than a technician's. It
// answers on the same endpoint and in the same shape (server/lib/leadShare.js),
// so the customer's page is one component and not two that drift apart.
const sharedDoc = () => {
  const m = /^\/d\/(estimates?|invoices?|lead-estimates?)\/([A-Za-z0-9_-]{20,})\/?$/.exec(window.location.pathname);
  if (!m) return null;
  const kind = m[1].replace(/s$/, '');
  return { kind, token: m[2] };
};

const shared = sharedDoc();

// ── /pay/<token> ───────────────────────────────────────────────────────────
//
// A customer following a pay link is not signed in and never will be. Same
// reasoning as the shared document above: the page renders on its own, with
// none of the app's screens, session restore or history handling behind it.
const payMatch = window.location.pathname.match(/^\/pay\/([A-Za-z0-9_-]{20,})\/?$/);

// ── /vendor-terms ──────────────────────────────────────────────────────────
//
// The agreement a technician accepts. Readable with no account, because they
// read it before they have one, and because somebody advising them should be
// able to open the link without being asked to sign in to anything.
const termsPage = /^\/vendor-terms\/?$/.test(window.location.pathname);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {shared
      ? <PublicDoc kind={shared.kind} token={shared.token} />
      : payMatch
        ? <PayScreen token={payMatch[1]} />
        : termsPage
          ? <VendorTerms />
          : <I18nProvider><App /></I18nProvider>}
  </React.StrictMode>
);
